export type Project = {
    title: string;
    description: string;
    miniatureUrl: string;
    videoUrl: string;
}

export const projects: Project[] = [
    {
        title: "DOCUMENTAIRE \"THE OLYMPIANS\"",
        description: "Extrait d'un documentaire de 45min, co-monté pour Eurosport",
        miniatureUrl: "/projects/olympians.png",
        videoUrl: "https://www.youtube.com/watch?v=nhzB41ZxGzg"
    },
    {
        title: "BABOLAT - OWN YOUR SPIN",
        description: "Spot pub",
        miniatureUrl: "/projects/babolat.jpg",
        videoUrl: "https://vimeo.com/745952715"
    },
    {
        title: "FRANCE 2 - 20H",
        description: "Bande annonce pour l'arrivée de Léa Salamé au 20h de France 2",
        miniatureUrl: "/projects/20h.png",
        videoUrl: "/projects/20h.mp4"
    },
    {
        title: "SPA/APRR",
        description: "Spot pub",
        miniatureUrl: "/projects/spa.jpg",
        videoUrl: "https://vimeo.com/278795376"
    },
    {
        title: "VOLVIC ZEST CASSIS ROMARAIN",
        description: "Spot pub",
        miniatureUrl: "/projects/volvic.jpg",
        videoUrl: "/projects/volvic.mp4"
    },
    {
        title: "EUROSPORT - TIMO BOLL",
        description: "Portrait d'athlète",
        miniatureUrl: "/projects/timoboll.png",
        videoUrl: "https://www.youtube.com/watch?v=L82pICx9g_g"
    },
    {
        title: "EUROSPORT - CHARLOTTE WORTHINGTON",
        description: "Portrait d'athlète",
        miniatureUrl: "/projects/charlotteworthington.png",
        videoUrl: "https://vimeo.com/861352066"
    },
    {
        title: "BERTRAND BELIN",
        description: "Clip vidéo",
        miniatureUrl: "/projects/bertrandbelin.png",
        videoUrl: "https://www.youtube.com/watch?v=xW2DoRNHF2s"
    },
    {
        title: "FRANCE TV - BONNES FÊTES 2021 - FILM 02",
        description: "Spot pub",
        miniatureUrl: "/projects/bonnesfetes.jpg",
        videoUrl: "https://vimeo.com/661599938"
    },
]